import { lazy } from 'react';
import Loadable from 'components/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';
import AdminLayout from 'layout/AdminLayout';

// Admin pages
const AdminLogin = Loadable(lazy(() => import('pages/admin/AdminLogin')));
const AdminUsers = Loadable(lazy(() => import('pages/admin/AdminUsers')));
const AdminDatabase = Loadable(lazy(() => import('pages/admin/AdminDatabase')));
const AdminInsights = Loadable(lazy(() => import('pages/admin/AdminInsights')));
const AdminFeedback = Loadable(lazy(() => import('pages/admin/AdminFeedback')));

// ==============================|| ADMIN ROUTING ||============================== //

const AdminRoutes = {
  path: '/admin',
  children: [
    {
      path: 'login',
      element: <AdminLogin />
    },
    {
      path: '',
      element: (
        <AdminGuard>
          <AdminLayout />
        </AdminGuard>
      ),
      children: [
        {
          path: 'users',
          element: <AdminUsers />
        },
        {
          path: 'database',
          element: <AdminDatabase />
        },
        {
          path: 'insights',
          element: <AdminInsights />
        },
        {
          path: 'feedback',
          element: <AdminFeedback />
        },
        {
          path: '',
          element: <AdminUsers />
        }
      ]
    }
  ]
};

export default AdminRoutes;
